// Date helper functions for timeframe parsing and validation

export const YM_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;

export const isValidYearMonth = (s) => !!(s && YM_REGEX.test(String(s).trim()));

export const parseTimeframe = (tf) => {
  // Returns { start: 'YYYY-MM' | '', end: 'YYYY-MM' | '', present: boolean }
  if (!tf || typeof tf !== 'string') return { start: '', end: '', present: false };
  const m = tf.trim().match(/^(\d{4})-(0[1-9]|1[0-2])\s*--\s*(?:(\d{4})-(0[1-9]|1[0-2])|(Present))$/);
  if (!m) return { start: '', end: '', present: false };
  const [, sy, sm, ey, em, present] = m;
  return {
    start: `${sy}-${sm}`,
    end: present ? '' : `${ey}-${em}`,
    present: !!present
  };
};

export const combineTimeframe = (start, end, present) => {
  if (!isValidYearMonth(start)) return '';
  if (present) return `${start} -- Present`;
  if (isValidYearMonth(end)) return `${start} -- ${end}`;
  return '';
};
